import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { SubscriptionService } from '../../../shard/service/subscription.service';
import { AppSettings } from 'src/app/app.constant';
import { DialogService } from '../../../shard/service/dialog.service'
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
@Component({
  selector: 'app-practice',
  templateUrl: './practice.component.html',
  styleUrls: ['./practice.component.css']
})
export class PracticeComponent implements OnInit {
  loading:boolean=true;

  myForm: FormGroup = new FormGroup({});

  user_id:any;
  private_key:any;
  loginname:any;
  fullname:any;
  Paper:any;
  qp_id:any;
  attemptid:any;
  Questions:any;
  QuestionsLength:any;
  isLoaded:any;
  errorMessage:any;
  true_answer:any;
  false_answer:any;
  AssessmentData:any;
  jsondata:any;
  httpResponseMessage:any;
  httpResponse:any;
  message:any;
  constructor(private fb: FormBuilder, private dialogService: DialogService,private route: ActivatedRoute,private router: Router, private location: Location, private _subscriptionService: SubscriptionService) { }

  ngOnInit(): void { 
    if(sessionStorage.getItem('user_id')==null) {
      this.router.navigate(['/home']); return;
    }
    this.user_id = sessionStorage.getItem('user_id');
    this.private_key = sessionStorage.getItem('private_key');
    this.fullname = sessionStorage.getItem('name');
    this.loginname = sessionStorage.getItem('loginname'); 
    this.qp_id = this.route.snapshot.paramMap.get('qpid');
    this.getQpDetails();
    this.loadQuestions(); 
    this.true_answer=0;
    this.false_answer=0;
    this.Paper = [{examname:""}];
    this.AssessmentData = [{user_id:"",private_key:"",qpid:"",qid:"",subcatid:"",specificid:"",qans:"",attempttype:"",attemptid:""}];
    this.createForm();
  }  

  createForm(){ 
    this.myForm = this.fb.group({
      nam:[this.fullname],
      mob:[this.loginname],
      sub:[this.attemptid],
      mes:[null, [Validators.required]],
      typ:['1'],
      });
  }; 

  successNotification(){
    const dataToComponent = {
      title: "Success.!!",
      message: "Feedback submitted successfully...!!",
      alertType: "Warning",
    }
    this.dialogService.openAlertDialog(dataToComponent);
  }

  validateContact(): void {
    this.myForm.controls['sub'].setValue(this.attemptid[0].id); //this.attemptid[0].id;
    if (this.myForm.invalid) {
      this.errorNotification();
        return;
    }
    this.jsondata = JSON.stringify(this.myForm.value); 
    this._subscriptionService.postData(AppSettings.API_ENDPOINT + AppSettings.contact, this.jsondata).subscribe(
    data => {
      this.httpResponse = data; console.log(data);
      if(this.httpResponse.isvalid==="Yes") 
      {
       this.successNotification();
       //this.router.navigate(['/home']);
       return;
      }
      else
      {
        this.errorNotification();
      } 
    },
    error => this.errorMessage = <any>error); 
  };

  reloadQuestions(): void{
    window.location.reload();
  }

  goBack(): void {
    this.location.back();
  }

  getQpDetails(): void {
		this.Paper = []; 
    this._subscriptionService.getData(AppSettings.API_ENDPOINT + AppSettings.qpdetails + '?qpid='+this.qp_id+'&user_id='+this.user_id+'&private_key='+this.private_key).subscribe(
    data => {
      this.Paper = data; //console.log(this.Paper);
      if(this.Paper.Message=='Unauthorised Access.!!') {
        this.router.navigate(['/loginform']); return;
      }
    },
    error => this.errorMessage = <any>error);
  }

  errorNotification(){
    const dataToComponent = {
      title: "Access Denied!",
      message: this.message,
      alertType: "Warning",
    }
    this.dialogService.openAlertDialog(dataToComponent);
  }

  loadQuestions():void {
		this.Questions = [];
    this._subscriptionService.getData(AppSettings.API_ENDPOINT + AppSettings.practice + '?qp_id='+this.qp_id+'&user_id='+this.user_id+'&private_key='+this.private_key).subscribe(
      data => {
        let HttpResponse=""; 
        this.Questions = data; 
        if(this.Questions[0].Question){ 
          HttpResponse=this.Questions[0].Question;
          if(HttpResponse.substring(0,30)=='Maximum Practice Count Reached'){
            this.message=this.Questions[0].Question;
            this.errorNotification();
            this.router.navigate(['/subscribenow']);
          }
        }  
        if(this.Questions[0].Question){ 
          if (this.Questions[0].Question=='Your Subscription Expired' ){
            this.message="Your Subscription Expired. Please recharge your wallet and subscribe for this examination.!!";
            this.errorNotification();
            this.router.navigate(['/subscribenow']);
          }
       }  
         this.QuestionsLength=this.Questions.length;
        
        this.Questions.forEach((e: any) => {
          if (e.name){
            if (e.qname?.substring(e.qname.length - 4, e.qname.length) == '</p>') {
              e.qname = e.qname.replace("<p>", "").slice(0,-4); 
            }
          }
          if (e.ch1){
            if (e.ch1.substring(e.ch1.length - 4, e.ch1.length) == '</p>') {
              e.ch1 = e.ch1.replace("<p>", "").slice(0,-4); 
            }
          }
          if (e.ch2){
            if (e.ch2.substring(e.ch2.length - 4, e.ch2.length) == '</p>') {
              e.ch2 = e.ch2.replace("<p>", "").slice(0,-4); 
            }
          }
          if (e.ch3){
            if (e.ch3.substring(e.ch3.length - 4, e.ch3.length) == '</p>') {
              e.ch3 = e.ch3.replace("<p>", "").slice(0,-4); 
            }
          }
          if (e.ch4){
            if (e.ch4.substring(e.ch4.length - 4, e.ch4.length) == '</p>') {
              e.ch4 = e.ch4.replace("<p>", "").slice(0,-4); 
            }
          }
        }); 

        this.loading=false;
        this.isLoaded=true;
        //start  get AttemptID
          this._subscriptionService.getData(AppSettings.API_ENDPOINT + AppSettings.attemptid + '?user_id='+this.user_id +'&private_key='+this.private_key).subscribe(
          data => {
            this.attemptid = data;
          },
          error => this.errorMessage = <any>error);
        //end  get AttemptID
      },
      error => this.errorMessage = <any>error);
	}
	
  getStatus(obj:any): boolean { 
		if(obj.stat==0) 
      return false
    else
      return true;
    };    

  getScore(question:any,index:any,icon:any,$event:any): void {
    let answer=0;
    question.stat = 1;

    if ($event.target.value == question.qans){ 
      answer=1;
      this.true_answer++; 
      $("#IC" + $event.target.value + index).css("background-color", "green");
      $("#IC" + $event.target.value + index).css("color", "white");
    }
    else
    {   
      this.false_answer++;
      $("#IC" + $event.target.value + index).css("background-color", "red");
      $("#IC" + question.qans + index).css("background-color", "green");

      $("#IC" + $event.target.value + index).css("color", "white");
      $("#IC" + question.qans + index).css("color", "white");
    } 

    this.AssessmentData = {
        'user_id':this.user_id,
        'private_key':this.private_key,
        'qpid':this.qp_id,
        'qid':question.qid,
        'subcatid':question.subcat_id,
        'specificid':question.specific_id,
        'qans':answer,
        'attempttype':2,
        'attemptid':this.attemptid[0].id
    };

    this.jsondata = this.AssessmentData ; 
    //this.jsondata = JSON.stringify(this.AssessmentData.value); console.log(this.jsondata);
      this._subscriptionService.postData(AppSettings.API_ENDPOINT + AppSettings.assessment, this.AssessmentData).subscribe(
        data => {
          this.httpResponseMessage = data
        },
        error => this.errorMessage = <any>error)
  }

  viewResult(): void{
    this.router.navigate(['/viewresult/'+this.attemptid[0].id +'/'+this.qp_id]); 
  }

}
